import axios from 'axios';
import { getBaseUrlAnalista, ensureProtocol } from '../config/backend';

function getBase() {
  return getBaseUrlAnalista() || ensureProtocol(localStorage.getItem('ipBackend2') || '');
}

function getAuthHeaders() {
  const token = localStorage.getItem('token');
  return token ? { Authorization: token.startsWith('Bearer ') ? token : 'Bearer ' + token } : {};
}

export async function fetchCategoriasTodos() {
  const base = getBase();
  if (!base) return [];
  try {
    const res = await axios.get(base + '/categorias', { headers: getAuthHeaders(), timeout: 10000 });
    return Array.isArray(res?.data) ? res.data : [];
  } catch (err) {
    console.error('Erro ao listar categorias:', err);
    return [];
  }
}

export async function createCategoria(body) {
  const base = getBase();
  if (!base) throw new Error('Backend não configurado');
  return axios.post(base + '/categorias', body, { headers: getAuthHeaders() });
}

export async function updateCategoria(id, body) {
  const base = getBase();
  if (!base) throw new Error('Backend não configurado');
  return axios.put(base + '/categorias/' + id, body, { headers: getAuthHeaders() });
}

export async function deleteCategoria(id) {
  const base = getBase();
  if (!base) throw new Error('Backend não configurado');
  return axios.delete(base + '/categorias/' + id, { headers: getAuthHeaders() });
}

export async function duplicarCategoriasParaEmpresa(ids, empresaDestinoId) {
  const base = getBase();
  if (!base) throw new Error('Backend não configurado');
  return axios.post(base + '/categorias/duplicar-para-empresa', { ids, empresa_destino_id: empresaDestinoId }, { headers: getAuthHeaders() });
}

export async function fetchTiposChamadoTodos() {
  const base = getBase();
  if (!base) return [];
  try {
    const res = await axios.get(base + '/tipos-chamado', { headers: getAuthHeaders(), timeout: 10000 });
    return Array.isArray(res?.data) ? res.data : [];
  } catch (err) {
    console.error('Erro ao listar tipos de chamado:', err);
    return [];
  }
}

export async function createTipoChamado(body) {
  const base = getBase();
  if (!base) throw new Error('Backend não configurado');
  return axios.post(base + '/tipos-chamado', body, { headers: getAuthHeaders() });
}

export async function updateTipoChamado(id, body) {
  const base = getBase();
  if (!base) throw new Error('Backend não configurado');
  return axios.put(base + '/tipos-chamado/' + id, body, { headers: getAuthHeaders() });
}

export async function deleteTipoChamado(id) {
  const base = getBase();
  if (!base) throw new Error('Backend não configurado');
  return axios.delete(base + '/tipos-chamado/' + id, { headers: getAuthHeaders() });
}

export async function duplicarTiposChamadoParaEmpresa(ids, empresaDestinoId) {
  const base = getBase();
  if (!base) throw new Error('Backend não configurado');
  return axios.post(base + '/tipos-chamado/duplicar-para-empresa', { ids, empresa_destino_id: empresaDestinoId }, { headers: getAuthHeaders() });
}

export async function fetchStatusChamadoTodos() {
  const base = getBase();
  if (!base) return [];
  try {
    const res = await axios.get(base + '/status-chamado', { headers: getAuthHeaders(), timeout: 10000 });
    return Array.isArray(res?.data) ? res.data : [];
  } catch (err) {
    console.error('Erro ao listar status de chamado:', err);
    return [];
  }
}

export async function createStatusChamado(body) {
  const base = getBase();
  if (!base) throw new Error('Backend não configurado');
  return axios.post(base + '/status-chamado', body, { headers: getAuthHeaders() });
}

export async function updateStatusChamado(id, body) {
  const base = getBase();
  if (!base) throw new Error('Backend não configurado');
  return axios.put(base + '/status-chamado/' + id, body, { headers: getAuthHeaders() });
}

export async function deleteStatusChamado(id) {
  const base = getBase();
  if (!base) throw new Error('Backend não configurado');
  return axios.delete(base + '/status-chamado/' + id, { headers: getAuthHeaders() });
}

export async function duplicarStatusChamadoParaEmpresa(ids, empresaDestinoId) {
  const base = getBase();
  if (!base) throw new Error('Backend não configurado');
  return axios.post(base + '/status-chamado/duplicar-para-empresa', { ids, empresa_destino_id: empresaDestinoId }, { headers: getAuthHeaders() });
}
